import React, { useEffect } from "react"
import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"
import backgroundImg from "../static/media/aboutUs/aboutus-main.webp"
import Main from "../components/AboutUs/Main"
import MissionVision from "../components/AboutUs/MissionVision"
import Values from "../components/AboutUs/Values"
import PromoWeb from "../components/Home/PromoWeb"

export default function ContactPage() {
  useEffect(() => {
    document.title = "CMSOLTEC | Sobre Nosotros"
    window.scrollTo(0, 0)
  }, [])

  return (
    <div>
      <Main />

    <Box
      sx={{
        position: "relative",
        height: { xs: "140vh", md: "160vh" } 
      }}
    >
      <Box
        sx={{
          position: "sticky",
          top: "10vh", 
          height: { xs: "60vh", md: "80vh" } ,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          color: "#fff",
          backgroundImage: `url(${backgroundImg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          zIndex: 1
        }}
      >
        <Box sx={{ position: "absolute", inset: 0, background: "rgba(0,0,0,.5)",
        }} />
        <Box sx={{ position: "relative", px: 2 }}>
          <Typography
            variant="h1"
            sx={{
              fontWeight: 750,
              textShadow: "0 0 15px rgba(0,0,0,0.95)",
              lineHeight: 1.1,
              fontSize: { xs: "1.5rem", md: "3rem" },
              maxWidth: 900,
              mb: 2
            }}
          >
            Soluciones tecnológicas que impulsan tu crecimiento.
          </Typography>
          <Typography
            variant="h2"
            sx={{
              fontWeight: 600,
              textShadow: "0 0 8px rgba(0,0,0,0.9)",
              fontSize: { xs: "1rem", md: "1.5rem" },
              letterSpacing: "0.5px"
            }}
          >
            CMSOLTEC
          </Typography>
        </Box>
      </Box>
    </Box>

    <Box
      sx={{
        position: "relative",
        zIndex: 2,
        marginTop: "-80vh",
        background: "#fff",
        display: "flex",
        flexDirection: "column"
      }}
    >
      <Values />
      <MissionVision />
    </Box>
      <PromoWeb />
    </div>
  )
}
